// Rotas públicas de contratos (cobrança, links de assinatura/locação/serviço e impressões).
// Migradas do submódulo f-erp-contratos (servicos/assinaturas/locacoes/shared) para o build
// principal do f-erp, pois usam paths de raiz (/contrato/:hash, /loc/:hash, /locacoes/imprimir_*,
// etc.) e precisam responder mesmo sem o submódulo contratos carregado — o SPA do módulo
// (modules/contratos) só atende paths sob /contratos/. Apenas as rotas public:true.
//
// As impressões por :id (imprimir_contrato/imprimir_pdf/imprimir_devolucao) entram aqui porque
// o módulo as abre com :href em path de raiz (sem prefixo /contratos/), caindo no build principal.

// ===== Redirecionamentos de rotas antigas → módulo Contratos =====
// Muitos links e integrações ainda apontam para as rotas planas antigas
// (ex.: /contratos_servicos, /servicos_recorrentes, /locacoes). Os CRUDs migraram
// para src/modules/contratos (submodules gestao_contratos/gestao_assinaturas/gestao_locacoes),
// que em produção são builds SPA separados — por isso o redirect é via location.href
// (recarregamento completo), feito pelo componente RedirecionaModulo a partir de
// meta.destino. Cada prefixo gera 2 rotas: a exata (lista) e a curinga (/*) para
// adicionar/editar/visualizar/etc.
//
// IMPORTANTE: estes redirects são concatenados DEPOIS das rotas public:true acima.
// O Vue Router casa na ordem de declaração, então as impressões específicas
// (/locacoes/imprimir_contrato/:id, /locacoes/imprimir_devolucao/:id,
// /contratos_servicos/imprimir_pdf/:id) continuam sendo atendidas pelo build
// principal e não caem no curinga.
const RedirecionaModulo = () => import('../components/RedirecionaModulo')

const mapaRedirecionamentos = [
    // submodule gestao_contratos → /contratos/gestao_contratos
    ['/contratos_servicos', '/contratos/gestao_contratos'],
    ['/atributos_contratos', '/contratos/gestao_contratos'],
    ['/situacoes_contratos', '/contratos/gestao_contratos'],
    ['/relatorios_contratos', '/contratos/gestao_contratos'],
    // submodule gestao_assinaturas → /contratos/gestao_assinaturas
    ['/servicos_recorrentes', '/contratos/gestao_assinaturas'],
    ['/situacoes_servicos_recorrentes', '/contratos/gestao_assinaturas'],
    ['/relatorios_assinaturas', '/contratos/gestao_assinaturas'],
    // submodule gestao_locacoes → /contratos/gestao_locacoes
    ['/locacoes', '/contratos/gestao_locacoes'],
    ['/situacoes_locacoes', '/contratos/gestao_locacoes'],
    ['/relatorios_locacoes', '/contratos/gestao_locacoes'],
]

const redirecionamentos = []
mapaRedirecionamentos.forEach((par) => {
    const prefixo = par[0]
    const destino = par[1]
    redirecionamentos.push({ path: prefixo, component: RedirecionaModulo, meta: { public: true, destino } })
    redirecionamentos.push({ path: prefixo + '/*', component: RedirecionaModulo, meta: { public: true, destino } })
})

const routes = [
    {
        name: 'linkCobrancaContrato',
        path: '/cobranca_contrato/:hash',
        alias: ['/prop_contrato/:hash', '/cobranca_locacao/:hash'],
        component: () => import('../components/CobrancaServico'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'impressaoContratoAssinatura',
        path: '/contrato_assinatura/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkCobrancaAssinatura',
        path: '/link_assinatura/:hash',
        component: () => import('../components/CobrancaAssinatura'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkContratoAssinaturaEnvio',
        path: '/assin/:hash',
        component: () => import('../components/Envio'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'impressaoContratoLocacao',
        path: '/locacoes/imprimir_contrato/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkContratoLocacao',
        path: '/contrato_locacao/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkContratoLocacaoEnvio',
        path: '/loc/:hash',
        component: () => import('../components/Envio'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'impressaoContratoServico',
        path: '/contratos_servicos/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkContratoServico',
        path: '/contrato_servico/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'linkContratoServicoEnvio',
        path: '/contrato/:hash',
        component: () => import('../components/Envio'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'impressaoDevolucaoLocacao',
        path: '/locacoes/imprimir_devolucao/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    // Curingas de redirect — sempre por último (ver nota no topo do arquivo)
    ...redirecionamentos
]

export default routes
